module.exports = __webpack_public_path__ + "static/TT1332_TW-MARK-D10-clean-21969a9380841a43ef27340f90be1d12.png";